import { get, post } from '@/httpRequest/http'
const { VUE_APP_NEWS = '' } = process.env
import { getBaseUrl } from '@/utils'
const NewsBaseUrl = getBaseUrl(VUE_APP_NEWS)

export const getList = data => {
    return post(`${NewsBaseUrl}/news/v2/special/list`, { data, noEncTag: true, encrypt: 0 })
}

export const getDetail = params => {
    return get(`${NewsBaseUrl}/news/v2/special/detail`, { params, noEncTag: true, encrypt: 0 })
}

export const getRelated = data => {
    return post(`${NewsBaseUrl}/news/v2/special/related`, { data, noEncTag: true, encrypt: 0 })
}

/** 进入专题页 PV +1 */
export const specialViewUpd = data => {
    return post(`${NewsBaseUrl}/news/v2/special/view/upd`, { data, noEncTag: true, encrypt: 0 })
}

/** 图文卡片分享转发计数 +1 */
export const shareNumUpd = data => {
    return post(`${NewsBaseUrl}/news/v2/userEvent/share/upd`, { data, noEncTag: true, encrypt: 0 })
}
